import React, {
	useEffect,
	useState,
	useRef,
	Fragment,
	memo,
} from 'react'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import ResponsiveImage from 'root/src/client/web/static/reusable/ResponsiveImage'
import classNames from 'classnames'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
// import Icon from 'root/src/client/web/base/Icon'
import {
	ltGtMediaQuery,
	colorsNew,
	ltMdMediaQuery,
	ltSmMediaQuery,
	gtMdMediaQuery,
	dropShadow,
	textShadow,
} from 'root/src/client/web/commonStyles'
import withStyles from '@material-ui/core/styles/withStyles'
import urlParser from 'root/src/shared/util/urlParser'
import YTPlayer from 'root/src/client/web/base/Player/YTPlayer'
import useScript from 'root/src/client/web/hooks/useScript'
import { ytPlayerSrc } from 'root/src/shared/constants/playerUrls'
import { idKey } from 'root/src/shared/constants/keys'
import propOr from 'ramda/src/propOr'
import ButtonNew from 'root/src/client/web/base/ButtonNew'
import { GET_STARTED_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import reduce from 'ramda/src/reduce'
import isEmpty from 'ramda/src/isEmpty'
import { isVideoType, isYoutubeVideo } from 'root/src/client/util/isVideoType'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/pro-regular-svg-icons/faPlay'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
// import { platformIconMap } from 'root/src/shared/constants/dropKeys'
import TooltipWrapper from 'root/src/client/web/base/TooltipWraper'
import TextWithClickableLinks from 'root/src/client/web/base/TextWithClickableLinks'
import { PrizesAvailableProgressBar, PointsAvailableProgressBar } from 'root/src/client/web/record/DropEvent/Progress'
import { HeroSectionStyle } from 'root/src/client/web/record/DropEvent/styles'
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls'
import { useModal } from 'root/src/client/v2/common/contexts/modal.context'
import { PointsApplicationModal } from 'root/src/client/web/modal/PointsApplicationModal'
import { getDateWithTimezone } from 'root/src/shared/util/getDateWithTimezone'
import DaresSlider from './DaresSlider'

const dropIsOverLayoutStyle = {
	root: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		left: -15,
		top: -15,
		padding: 15,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 30,
		zIndex: 2,
		background: 'rgba(0, 0, 0, .75)',
		[ltGtMediaQuery]: {
			top: 0,
			padding: 0,
			left: 0,
			borderRadius: 0,
			transform: 'none',
			position: 'fixed',
			height: '-webkit-fill-available',
		},
	},
	gameOver: {
		position: 'sticky',
		top: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		border: '10px solid #ff0000',
		borderRadius: 30,
		margin: [[12, 0]],
		[ltSmMediaQuery]: {
			margin: 12,
			fontSize: 50,
		},
	},
	gameOverText: {
		color: '#ff0000',
		fontFamily: 'Bodoni Moda, monospace',
		fontWeight: 700,
		textAlign: 'center',
		textShadow: '4px 4px 5px rgba(0, 0, 0, 0.65)',
		userSelect: 'none',
		padding: [[5, 40]],
		[gtMdMediaQuery]: {
			fontSize: 95,
		},
		[ltMdMediaQuery]: {
			fontSize: 70,
		},
		[ltSmMediaQuery]: {
			padding: [[5, 10]],
			fontSize: 50,
		},
	},
	shadowText: {
		filter: dropShadow(colorsNew.primary),
	},
	columnText: {
		textShadow: textShadow('rgba(0, 0, 0, .25)'),
		textAlign: 'center',
		margin: [[5, 0]],
	},
	textBold: {
		fontWeight: 700,
	},
	link: {
		cursor: 'pointer',
	},
}

const DropIsOverLayout = withStyles(dropIsOverLayoutStyle, { name: 'MuiDropIsOverLayout' })(
	memo(({ classes, label, pushRouteFn }) => (
		<div
			className={classes.root}
		>
			<div className={classes.gameOver}>
				<Typography
					color="#ff0000"
					variant={typographyVariants.heading1}
					className={classes.gameOverText}
				>
					GAME OVER
				</Typography>
			</div>
			<Typography
				className={classNames(
					classes.columnText,
					classes.textBold,
				)}
				variant={typographyVariants.paragraphBold}
			>
				CONTINUE?
			</Typography>
			<Typography
				onClick={() => pushRouteFn()}
				className={classNames(
					classes.columnText,
					classes.shadowText,
					classes.link,
				)}
				variant={typographyVariants.heading1}
			>
				{label}
			</Typography>
		</div>
	)),
)

const MediaPlayer = ({ classes, mediaArr }) => {
	const [activeMedia, setActiveMedia] = useState(0)
	const mediaItemsRef = useRef([])
	useEffect(() => {
		setTimeout(() => {
			mediaItemsRef.current.forEach((child, idx) => {
				// eslint-disable-next-line no-param-reassign
				child.style.display = idx === activeMedia ? 'flex' : 'none'
			})
		}, 290)
	}, [activeMedia])
	const [ytLoaded] = useScript(ytPlayerSrc)

	return (
		<div className={classes.media}>
			<div className={classes.playerArea}>
				{mediaArr.map(
					(item, idx) => (
						<div
							ref={(ref) => {
								mediaItemsRef.current[idx] = ref
							}}
							className={classes.playerImage}
							style={{
								opacity: activeMedia === idx ? 1 : 0,
								// justifyContent: 'center',
							}}
							key={item.fileHash ? item.fileHash : item.url}
						>
							{item.videoId ? (
								<Fragment>
									{ytLoaded && (
										<YTPlayer
											videoId={item.videoId}
										/>
									)}
								</Fragment>

							) : (
								<ResponsiveImage
									imageObj={item}
									controls
								/>
							)}
						</div>
					),
					mediaArr,
				)}
			</div>
			<div className={classes.thumbnails}>
				{mediaArr.map(
					(item, idx) => (
						<div
							className={classNames(
								classes.thumbnailContainer,
								idx === activeMedia && classes.activeThumbnail,
							)}
							onClick={() => setActiveMedia(idx)}
							key={item.fileHash ? item.fileHash : item.url}
						>
							{item.url && (
								<div className={
									classes.playIconWrapper}
								>
									<FontAwesomeIcon
										icon={faPlay}
										size="3x"
									/>
								</div>
							)}
							{item.videoId ? (
								<img
									src={`https://img.youtube.com/vi/${item.videoId}/0.jpg`}
									alt="thumbnail"
									width="118"
									height="65"
								/>
							) : (
								<ResponsiveImage
									imageObj={item}
									thumbnail
									width="118"
									height="65"
								/>
							)}
						</div>
					),
				)}
			</div>
		</div>
	)
}

const Helper = ({
	classes, isAuthenticated, comingSoon,
	emailSubscription, toggleEmailSubscription, displayModal,
}) => {
	const [error, setError] = useState('')

	if (isAuthenticated && !comingSoon) {
		return null
	}

	const content = isAuthenticated && comingSoon
		? (emailSubscription
			? {
				text: 'Cancel email notification',
				buttonLabel: 'Drop joined',
				onClick: () => toggleEmailSubscription(setError),
			} : {
				text: 'Want to be notified when this drop goes live?',
				buttonLabel: 'Notify me',
				onClick: () => toggleEmailSubscription(setError),
			})
		: {
			text: 'Ready to do a drop but dont know where to begin?',
			buttonLabel: 'Get Started',
			onClick: () => displayModal(GET_STARTED_MODULE_ID),
		}
	return (
		<TooltipWrapper tooltipText={error} visible>
			<div className={classes.helperContainer}>
				<p className={classes.helperText}>
					{content.text}
				</p>
				<div className={classes.helperAction}>
					<ButtonNew
						className={classes.helperActionButton}
						onClick={content.onClick}
					>
						{content.buttonLabel}
					</ButtonNew>
				</div>
			</div>
		</TooltipWrapper>
	)
}

const HeroSection = ({
	classes, gameName, gameDescriptionBody, rating, brandName, followerCount,
	assets, tags, regions, dares, isAuthenticated, campaignId,
	submitting, setSubmitting, availablePrizes, isDropOver, isBrand, status, redirectAndPrePopulate,
	displayModal, comingSoon, emailSubscription, toggleEmailSubscription, totalPrizes,
	initialProduct, pointsToEarn, isGameFree, canEarnPoints, pointsLimit, pointsAwarded, isAdmin,
	canUserReclaimReservation, displayHowToEarnPointsModal,	displaySponsorshipDetailsModal,
	pointsReserved, isCreator, showTermsModal, isAbleToParticipate, isCommunityDrop, canAccept, youtubeURL,
	pointsApplicationState, pointsApplicationsEnabled, pointsStreamLimit, liveDate, isCreatorPointsAllowlisted,
	// platforms,
}) => {
	const modal = useModal()
	const assetsUpdated = [
		...(youtubeURL ? [{ url: youtubeURL }] : []),
		...assets,
	]
	const getYoutubeId = video => propOr('', idKey, urlParser(video))
	const mediaArr = reduce((acc, curr) => {
		if (!curr) return acc

		const isVideo = isVideoType(curr?.url || '')
		const isYoutube = isYoutubeVideo(curr?.url || '')

		return [
			...acc,
			{
				...(isYoutube ? { videoId: getYoutubeId(curr.url) } : {}),
				...(isVideo ? {
					...curr,
					mobile: addHttpsProtocol(curr.url),
					desktop: addHttpsProtocol(curr.url),
				} : curr),
			},
		]
	}, [], assetsUpdated)

	const pushRouteFn = isBrand
		? () => pushRouteClient({ routeId: routeUrls.addCampaign() })
		: () => pushRouteClient({ routeId: routeUrls.drops() })

	const displaySignUpModule = () => {
		if (!isAuthenticated) {
			displayModal(GET_STARTED_MODULE_ID)
		}
	}

	const isShowPrizesProgress = totalPrizes && !isGameFree
	const isShowPointsProgress = (canEarnPoints || isAdmin) && pointsLimit

	return (
		<div className={classes.heroSectionContainer}>
			{isDropOver && !comingSoon && (
				<DropIsOverLayout
					redirectAndPrePopulate={redirectAndPrePopulate}
					label={isBrand
						? 'Launch a New Campaign'
						: 'CHECK OUT OUR ACTIVE DROPS'
					}
					pushRouteFn={pushRouteFn}
				/>
			)}
			<div className={classes.gameSection}>
				<div className={classes.gameInfo}>
					<div className={classes.gameDescription}>
						<Typography variant={typographyVariants.heading1}>
							{gameName}
						</Typography>
						<div className={classes.subHeadingContainer}>
							<Typography color={colorsNew.light3} variant={typographyVariants.microBold}>
								{brandName}
							</Typography>
							{rating && (
								<div>
									<Typography color={colorsNew.light3} variant={typographyVariants.micro}>
										{'ALL REVIEWS: '}
									</Typography>
									<Typography color={colorsNew.light3} variant={typographyVariants.microBold}>
										{`${rating.label} (${rating.amount})`}
									</Typography>
								</div>
							)}
						</div>
						{comingSoon && (
							<div className="py-2">
								<Typography color={colorsNew.light3} variant={typographyVariants.heading4}>
									Drop starts {getDateWithTimezone(liveDate)}
								</Typography>
							</div>
						)}
						<Typography variant={typographyVariants.small}>
							<TextWithClickableLinks text={gameDescriptionBody} />
						</Typography>
					</div>
					<div className={classes.tags}>
						{tags && (
							<div>
								<Typography variant={typographyVariants.micro} color={colorsNew.light3}>
									TAGS
								</Typography>
								<div className={classes.tagGroup}>
									{tags.map(label => (
										<div className={classes.pile} key={label}>
											<Typography variant={typographyVariants.microBold}>{label}</Typography>
										</div>
									))}
								</div>
							</div>
						)}
						{/* {!isEmpty(platforms) && ( */}
						{/* 	<div> */}
						{/* 		<Typography color={colorsNew.light3} variant={typographyVariants.micro}> */}
						{/* 			PLATFORMS */}
						{/* 		</Typography> */}
						{/* 		<div className={classes.tagGroup}> */}
						{/* 			{platforms.map(platform => ( */}
						{/* 				<Icon */}
						{/* 					icon={platformIconMap[platform]} */}
						{/* 					color={colorsNew.light4} */}
						{/* 					className={classes.platformIcon} */}
						{/* 					size={20} */}
						{/* 					key={platform} */}

						{/* 				/> */}
						{/* 			))} */}
						{/* 		</div> */}
						{/* 	</div> */}
						{/* )} */}
						<div>
							<Typography
								variant={typographyVariants.micro}
								color={colorsNew.light3}
							>
								LOCATIONS
							</Typography>
							<div className={classes.tagGroup}>
								{isEmpty(regions) ? (
									<div className={classes.pile}>
										<Typography variant={typographyVariants.microBold}>
											Worldwide
										</Typography>
									</div>
								) : (
									regions.map(label => (
										<div className={classes.pile} key={label}>
											<Typography variant={typographyVariants.microBold}>
												{label}
											</Typography>
										</div>
									))
								)}
							</div>
						</div>
					</div>
				</div>
				{mediaArr.length > 0 && (
					<MediaPlayer
						classes={classes}
						mediaArr={mediaArr}
					/>
				)}
			</div>
			<div className={classes.daresSliderSection}>
				<Helper
					{...{
						classes,
						isAuthenticated,
						comingSoon,
						emailSubscription,
						toggleEmailSubscription,
						displayModal,
					}}
				/>
				{
					canEarnPoints
						&& pointsApplicationsEnabled
						&& pointsApplicationState === undefined
						&& pointsLimit - pointsAwarded > 0
						&& !isCreatorPointsAllowlisted
						? (
							<div className={classes.sponsorshipContainer}>
								<ButtonNew
									onClick={() => modal.show(<PointsApplicationModal />)}
									className="w-[260px]"
								>
									APPLY FOR POINTS
								</ButtonNew>
							</div>
						) : undefined}
				{isCreator ? (
					<div className={classNames(classes.sponsorshipContainer, 'w-[260px]')}>
						<ButtonNew onClick={displaySponsorshipDetailsModal}>
							{	isCommunityDrop ? 'SEE PARTICIPATION DETAILS' : 'SEE SPONSORSHIP DETAILS' }
						</ButtonNew>
					</div>
				) : undefined}
				{(isCreator && (isShowPointsProgress || isShowPrizesProgress)) ? (
					<div className={classes.horizontalLine} />
				) : undefined}
				{isShowPrizesProgress ? (
					<PrizesAvailableProgressBar
						isAuthenticated={isAuthenticated}
						initialProduct={initialProduct}
						comingSoon={comingSoon}
						displaySignUpModule={displaySignUpModule}
					/>
				) : undefined}
				{isShowPointsProgress && (
					<PointsAvailableProgressBar
						pointsLimit={pointsLimit}
						pointsAwarded={pointsAwarded}
						pointsReserved={pointsReserved}
						canUserReclaimReservation={canUserReclaimReservation}
						displayHowToEarnPointsModal={displayHowToEarnPointsModal}
					/>
				)}
				<div className={classes.horizontalLine} />
				<DaresSlider
					dares={dares}
					game={gameName}
					isAdmin={followerCount}
					isAuthenticated={isAuthenticated}
					campaignId={campaignId}
					submitting={submitting}
					setSubmitting={setSubmitting}
					availablePrizes={availablePrizes}
					status={status}
					comingSoon={comingSoon}
					pointsToEarn={pointsToEarn}
					pointsStreamLimit={pointsStreamLimit}
					canEarnPoints={canEarnPoints}
					toggleEmailSubscription={toggleEmailSubscription}
					emailSubscription={emailSubscription}
					showTermsModal={showTermsModal}
					isAbleToParticipate={isAbleToParticipate}
					canAccept={canAccept}
				/>
			</div>
		</div>
	)
}
export default withStyles(HeroSectionStyle, { name: 'MuiHeroSection' })(HeroSection)
